<template>
    <div>
        <el-col>
            <el-menu
            :unique-opened='true'
            :router="true"
            class="el-menu-vertical-demo"
            background-color="#001529"
            text-color="#A5ACB3"
            active-text-color="#3BA705"
            :default-active="logUrl.logUrl"
            @select="getIndex"
            :collapse="isCollapse"
            :collapse-transition = "false"
            >
                <common-menu :getMenu="getMenu" :isCollapse="isCollapse"></common-menu>
            </el-menu>
        </el-col>
    </div>
</template>
<script>
import CommonMenu from './Menu'
import { mapState,mapActions } from "vuex";
export default {
    name:'sidelist',
    props:{
        isCollapse:Boolean,
    },
    data(){
        return{
            getMenu:[
                // {
                //     menuName:"首页",
                //     id:1,
                //     menuUrl:"/home",
                //     children:null,
                //     menuIcon:'el-icon-s-home'
                // },
                // {
                //     menuName:"分销管理",
                //     id:2,
                //     menuIcon:'el-icon-s-marketing',
                //     children:[{
                //         menuName:"代理商管理",
                //         id:3,
                //         menuUrl:"/agentMag",
                //         children:null
                //     },
                //     {
                //         menuName:"分润明细",
                //         id:4,
                //         menuUrl:"/RestartMag",
                //         children:null
                //     },{
                //         menuName:"提现管理",
                //         id:5,
                //         menuUrl:"/cashWithdrawal",
                //         children:null
                //     }]
                // },
                // {
                //     menuName:"充值管理",
                //     id:6,
                //     menuUrl:"/customerMag",
                //     children:null,
                //     menuIcon:'el-icon-s-cooperation'
                // },
                // {
                //     menuName:"物联网管理",
                //     id:7,
                //     menuIcon:'el-icon-s-platform',
                //     children:[{
                //         menuName:"卡片管理",
                //         id:8,
                //         menuUrl:"/operatorFlow",
                //         children:null
                //     },{
                //         menuName:"导入记录",
                //         id:9,
                //         menuUrl:"/ImportMag",
                //         children:null
                //     },{
                //         menuName:"拨卡记录",
                //         id:10,
                //         menuUrl:"/userFlowList",
                //         children:null
                //     }
                //     ]
                // },
                // {
                //     menuName:"通道管理",
                //     id:11,
                //     menuUrl:"/channelMag",
                //     children:null,
                //     menuIcon:'el-icon-s-data'
                // },
                // {
                //     menuName:"套餐管理",
                //     id:12,
                //     menuUrl:"/setmealMag",
                //     children:null,
                //     menuIcon:'el-icon-s-grid'
                // },
                // {
                //     menuName:"文件下载中心",
                //     id:50,
                //     menuUrl:"/fileDownloadMag",
                //     menuIcon:'el-icon-upload',
                //     children:null
                // },
                // {
                //     menuName:"个人中心",
                //     id:30,
                //     menuIcon:'el-icon-s-help',
                //     children:[{
                //         menuName:"基本资料",
                //         id:31,
                //         menuUrl:"/basicData",
                //         children:null
                //     }
                //     ]
                // },
                // {
                //     menuName:"系统设置",
                //     id:40,
                //     menuIcon:'el-icon-s-tools',
                //     children:[
                //         {
                //             menuName:"用户管理",
                //             id:41,
                //             menuUrl:"/backUserMag",
                //             children:null
                //         },{
                //             menuName:"权限管理",
                //             id:42,
                //             menuUrl:"/roleMag",
                //             children:null
                //         },{
                //             menuName:"菜单管理",
                //             id:43,
                //             menuUrl:"/menu",
                //             children:null
                //         },{
                //             menuName:"操作日志",
                //             id:44,
                //             menuUrl:"/operationLog",
                //             children:null
                //         },{
                //             menuName:"配置管理",
                //             id:45,
                //             menuUrl:"/toConfig",
                //             children:null
                //         }
                        
                //     ]

                // },
                
                // {
                //     name:"个人中心",
                //     menuurl:"/personalInfo",
                //     code:'personalInfo',
                //     icon:'el-icon-s-management',
                //     children:null
                // }
                ]
        }
    },
    components: {
        CommonMenu
    },
    computed:{
        ...mapState({  //比如'movies/hotMovies
            logUrl:state=>state.logUrl
        })
    },
    methods:{
        ...mapActions([  
            'saveMenu',"saveLogUrl"
        ]),
        // 存储点击的菜单
        getIndex(index,val){
            this.saveLogUrl({logUrl:index});
        },
        //获取菜单
        findTreeDatas:function(){
            this.$api.post(this.API.api + 'home/onLoadSysMenu',{},res=>{
                this.getMenu = res.data; 
                this.saveMenu(this.getMenu);
            })
        },
    },
    created(){
        this.findTreeDatas();
    },
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 240px;
    min-height: 400px;
  }
</style>




// WEBPACK FOOTER //
// src/views/pc/components/SideList.vue